// extracted by mini-css-extract-plugin
export var acitonButtons = "_mb-0";
export var additionalIcon = "_mb-f";
export var block = "_mb-1";
export var blockContent = "_mb-7";
export var blockDescription = "_mb-8";
export var blockIcon = "_mb-9";
export var blockTitle = "_mb-6";
export var border = "_mb-a";
export var center = "_mb-l";
export var edge = "_mb-b";
export var edgeLabel = "_mb-c";
export var edgePath = "_mb-d";
export var error = "_mb-e";
export var flowchart = "_mb-g";
export var flowchartContent = "_mb-h";
export var highlighted = "_mb-3";
export var hover = "_mb-4";
export var icon = "_mb-i";
export var left = "_mb-m";
export var navButton = "_mb-j";
export var navButtons = "_mb-k";
export var right = "_mb-n";
export var selected = "_mb-2";
export var small = "_mb-5";